import styled from '@emotion/styled';
import React from 'react';

interface ColorFieldProps {
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
}

const normalize = (value: string | undefined): string => {
  if (!value) return '#000000';
  if (/^#([0-9a-fA-F]{6})$/.test(value)) return value;
  if (/^#([0-9a-fA-F]{3})$/.test(value)) {
    const r = value[1];
    const g = value[2];
    const b = value[3];
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return '#000000';
};

const ColorField: React.FC<ColorFieldProps> = ({ value, onChange, placeholder }) => {
  const hex = normalize(value);
  return (
    <Root>
      <Swatch type="color" value={hex} onChange={(e) => onChange(e.target.value)} />
      <Text type="text" value={value ?? ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder ?? '#000000'} />
    </Root>
  );
};

export default ColorField;

const Root = styled.div`
  display: flex;
  gap: 6px;
  width: 100%;
  min-width: 0;
`;

const Swatch = styled.input`
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
`;

const Text = styled.input`
  flex: 1;
  min-width: 0;
  padding: 4px 6px;
  font-size: 13px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  outline: none;

  &:focus {
    border-color: #9ca3af;
  }
`;
